module.exports = __webpack_public_path__ + "static/assets/55138757aa9bcd62ba561af0d1b19074.png";